import { query } from '@confluence/query-preloader-tools';

import {
	EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED,
	useConfluenceStandardToPremiumExperimentQuery,
} from './useConfluenceStandardToPremiumExperiment';

export function preloadUseConfluenceStandardToPremiumExperimentQuery() {
	return query({
		query: useConfluenceStandardToPremiumExperimentQuery,
		variables: {
			key: EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED,
		},
	});
}
